import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatExpButton } from '@camaradesuk/m3e-angular';

@Component({
  selector: 'syrf-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrl: './cookie-consent-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, RouterLink, MatExpButton],
})
export class CookieConsentBannerComponent {
  readonly accepted = output<void>();
}
